import { Laptop, Plane, GraduationCap, Heart, Coffee, Dumbbell, Clock, Users } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [Laptop, Clock, Plane, GraduationCap, Heart, Dumbbell, Coffee, Users];

const CareersPerks = () => {
  const { t, tObject } = useLanguage();
  const perks = tObject<Array<{ title: string; description: string }>>("careersPerks.items");

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("careersPerks.title")}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t("careersPerks.description")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {perks.map((perk, index) => {
            const Icon = iconMap[index] || Laptop;
            return (
              <div key={index} className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{perk.title}</h3>
                <p className="text-sm text-muted-foreground">{perk.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareersPerks;
